<template>
  <div class="bg-white border-2 border-gray-400 shadow-inner rounded-lg p-2 md:p-4 my-8">
    <slot />
  </div>
</template>
